module.exports = "\n"


//////////////////
// WEBPACK FOOTER
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/layouts/tooltips/tooltips.component.html
// module id = ../../../../../src/app/theme/layouts/tooltips/tooltips.component.html
// module chunks = main